module.exports = __webpack_public_path__ + "static/media/new-footer.2f49ca15.png";